import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Policies.css';

const AllPolicies: React.FC = () => {
  const navigate = useNavigate();

  const policyCategories = [
    {
      title: 'Legal & User Agreements',
      policies: [
        { name: 'Terms & Conditions', path: '/terms', description: 'Our terms of service and user agreement' },
        { name: 'Privacy Policy', path: '/privacy', description: 'How we collect, use, and protect your data' },
        { name: 'Legal Compliance', path: '/legalcompliance', description: 'Our commitment to legal standards' },
      ]
    },
    {
      title: 'Privacy & Data Protection',
      policies: [
        { name: 'Consumer Health Data Privacy Policy', path: '/consent', description: 'Health data privacy and consent management' },
        { name: 'Cookie Policy', path: '/cookies', description: 'How we use cookies and tracking technologies' },
        { name: 'Privacy Settings', path: '/privacy-settings', description: 'Manage your privacy preferences' },
      ]
    },
    {
      title: 'Safety & Security',
      policies: [
        { name: 'Security Policy', path: '/security', description: 'Our security measures and protocols' },
        { name: 'Child Safety Policy', path: '/childsafety', description: 'Protecting minors and age restrictions' },
        { name: 'Safety Tips', path: '/safety-tips', description: 'Guidelines for staying safe on our platform' },
      ]
    },
    {
      title: 'Community Standards',
      policies: [
        { name: 'Content Policy', path: '/content', description: 'Content guidelines and moderation policies' },
        { name: 'Review Policy', path: '/review', description: 'How we moderate and review user content' },
      ]
    },
    {
      title: 'Account Management',
      policies: [
        { name: 'Account Deletion Policy', path: '/accountdeletion', description: 'How to delete your account and data' },
        { name: 'Customer Service Policy', path: '/customerservice', description: 'Our support and service commitments' },
      ]
    }
  ];

  return (
    <div className="terms-container">
      <h1 className="heart-title">All Policies</h1>
      <p className="date-subtitle">Last Updated: 01-05-2025</p>

      <p className="paragraph">
        Welcome to our comprehensive policies page. Here you can find all information about how we operate,
        protect your data, and maintain our community standards. Click on any policy to view details.
      </p>

      {policyCategories.map((category, index) => (
        <section key={index} className="policy-section">
          <h2 className="section-title">{category.title}</h2>

          {category.policies.map((policy, policyIndex) => (
            <div key={policyIndex} className="content-block" style={{ cursor: 'pointer' }} onClick={() => navigate(policy.path)}>
              <h3 className="sub-title" style={{ color: '#e91e63', marginBottom: '8px' }}>
                {policy.name}
              </h3>
              <p style={{ margin: 0, color: '#333', fontSize: '14px' }}>
                {policy.description}
              </p>
            </div>
          ))}
        </section>
      ))}

      <section className="contact-section">
        <h2 className="section-title">Contact Us</h2>
        <div className="content-block">
          <p>For any questions, concerns, or feedback regarding our policies, please contact us at:</p>
          <p style={{ marginTop: '10px' }}>
            📧 Email: <a href="mailto:paulfortuneltd@gmail.com" className="email">paulfortuneltd@gmail.com</a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default AllPolicies;
